export default {
  routes: [
    {
      name: 'contracts',
      path: '/directory/contract',
      component: () => import('./views/TheContractsPage.vue'),
    },

    {
      name: 'contract',
      path: '/directory/contract/:uuid',
      component: () => import('./views/TheContractPage.vue'),
    },

    {
      name: 'contracttypes',
      path: '/directory/contracttypes',
      component: () => import('./views/TheContractTypes.vue'),
    },

    {
      name: 'contracttype',
      path: '/directory/contracttypes/:uuid',
      component: () => import('./views/TheContractType.vue'),
    },
  ]
}
